import { useTranslation } from "react-i18next";
import styled from "styled-components";
import themeProps from "theme/themes";
import check from "assets/icons/check.svg";
import Button from "components/Button";

interface StepsProps {
  steps: string[];
  currentStep: number;
  setCurrentStep: any;
  submitLabel: string;
  onSubmit?: any;
  children: any;
}

const StepsWrapper = styled.div`
  display: flex;
  align-items: start;
  justify-content: center;
  overflow: hidden;
  margin-bottom: 24px;
  height: 52px;
  width: 100%;
`;

const Step = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
`;

const StepStatusBasic = styled.span`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 2px solid ${(props: themeProps) => props.theme.main.primary};
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StepStatus = styled(StepStatusBasic)(
  ({ current }: { current: boolean }) => ({
    backgroundColor: current ? "#7D02FA" : "#FFF",
  })
);

const StepLabelBasic = styled.p`
  font-size: 1.2rem;
  font-weight: 500;
  position: absolute;
  bottom: -20px;
  white-space: nowrap;
`;

const StepLabel = styled(StepLabelBasic)(
  ({ current }: { current: boolean }) => ({
    color: current ? "#7D02FA" : "#000",
  })
);

const ContentWrapper = styled.div`
  padding: 40px 60px;
  border: 1px solid ${(props: themeProps) => props.theme.main.primary};
  width: 100%;
  min-height: 65vh;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;

const ButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: 40px;
`;

const StepWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const LineBasic = styled.div`
  width: 5vw;
  max-width: 80px;
  background-color: red;
`;

const Line = styled(LineBasic)(({ current }: { current: boolean }) => ({
  backgroundColor: current ? "#7D02FA" : "#1A1A1A",
  height: current ? "3px" : "1px",
}));

const Icon = styled.img`
  width: 60%;
  height: 60%;
`;

const ChildrenWrapper = styled.div`
  width: 100%;
  height: 100%;
  margin-bottom: auto;
`;

const Steps = ({
  steps,
  currentStep,
  setCurrentStep,
  submitLabel,
  onSubmit,
  children,
}: StepsProps) => {
  const { t } = useTranslation("steps");

  return (
    <>
      <StepsWrapper>
        {steps.map((step, index) => (
          <StepWrapper key={step}>
            <Step key={step}>
              <StepStatus current={index <= currentStep}>
                {index < currentStep ? <Icon src={check} /> : null}
              </StepStatus>
              <StepLabel current={index === currentStep}>{t(step)}</StepLabel>
            </Step>
            {index < steps.length - 1 && <Line current={index < currentStep} />}
          </StepWrapper>
        ))}
      </StepsWrapper>

      <ContentWrapper>
        <ChildrenWrapper>{children}</ChildrenWrapper>
        <ButtonsWrapper>
          {currentStep > 0 ? (
            <Button
              label={t("back")}
              onClick={() => setCurrentStep((state: any) => state - 1)}
              styles={{ width: "50%" }}
            />
          ) : null}
          {currentStep < steps.length - 1 ? (
            <Button
              label={t("next")}
              onClick={() => setCurrentStep((state: any) => state + 1)}
              filled
              styles={
                currentStep > 0
                  ? { marginLeft: "50px", width: "50%" }
                  : { width: "50%", justifySelf: "center" }
              }
            />
          ) : null}
          {currentStep === steps.length - 1 ? (
            <Button
              label={submitLabel}
              onClick={onSubmit}
              filled
              styles={
                currentStep > 0
                  ? { marginLeft: "50px", width: "50%" }
                  : { width: "50%" }
              }
            />
          ) : null}
        </ButtonsWrapper>
      </ContentWrapper>
    </>
  );
};

export default Steps;
